export enum ENGINES {
  DOVE = 'DOVE', // Amazon Dove Ads
  MSA = 'MSA', // Microsoft Ads
  PIQ = 'PIQ' // Promote IQ Ads
}

export const engineAdsPriorityOrder = [ENGINES.DOVE, ENGINES.PIQ, ENGINES.MSA];
export const FEATURE_DOVE_ADS = 'marty.ads.dove';
export const FEATURE_PIQ_ADS = 'marty.ads.piq';
export const FEATURE_MSA_ADS = 'marty.ads.msa';
